import { ComponentType, ReactElement } from 'react';

import ErrorBoundary from 'components/common/ErrorBoundary/ErrorBoundary';

const withErrorBoundary = <P extends Record<string, unknown>>(WrappedComponent: ComponentType<P>) => {
    return function Wrap(props: P): ReactElement {
        return (
            <ErrorBoundary>
                <WrappedComponent {...(props || {})} />
            </ErrorBoundary>
        );
    };
};

export default withErrorBoundary;
